import { Injectable } from '@angular/core';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AllocationViewRestoreActionState } from './allocation-view-restore-action.state';
import {
  AllocationViewRestoreAction,
  AllocationViewRestoreActionSetInitialState,
} from './allocation-view-restore-action.actions';

@Injectable({ providedIn: 'root' })
export class AllocationViewRestoreActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewRestoreActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewRestoreAction({
            identifier,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewRestoreActionSetInitialState());
  }
}
